var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.7 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1{fill:#fff}.st1{stroke:#fff;stroke-width:.16;stroke-miterlimit:10}.st2{fill:url(#path64_1_)}.st3{fill:url(#path78_1_)}.st4{fill:url(#path88_1_)}.st5{fill:url(#path104_1_)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "st0",
    d: "M130.5 1.1c2.3 0 4.2 1.9 4.2 4.2V35c0 2.3-1.9 4.2-4.2 4.2H5.2C2.9 39.1 1 37.3 1 35V5.3C1 3 2.9 1.1 5.2 1.1h125.3m0-.8H5.2c-2.8 0-5 2.2-5 5V35c0 2.7 2.3 5 5 5h125.3c2.8 0 5-2.2 5-5V5.3c.1-2.8-2.2-5-5-5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "st1",
    d: "M47.8 10.5c0 .8-.3 1.5-.7 2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2s.3-1.6.9-2.2c.6-.6 1.3-.9 2.2-.9.4 0 .8.1 1.2.3.4.2.7.4.9.7l-.5.5c-.4-.5-.9-.7-1.7-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7c.5.4 1 .7 1.6.7.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2V10h2.9c0 .2.1.3.1.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "st1",
    d: "M52.4 8h-2.7v1.9h2.5v.7h-2.5v1.9h2.7v.7h-3.5V7.3h3.5V8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "st1",
    d: "M55.6 13.2h-.8V8h-1.7v-.7h4.1V8h-1.7v5.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "st1",
    d: "M60.3 13.2V7.3h.8v5.9h-.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "st1",
    d: "M64.5 13.2h-.8V8H62v-.7h4.1V8h-1.7c.1 0 .1 5.2.1 5.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "st1",
    d: "M74 12.4c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "st1",
    d: "M76 13.2V7.3h.9l2.9 4.6V7.3h.8v5.9h-.8l-3.1-4.8v4.8H76z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "st0",
    d: "M68.5 21.9c-2.4 0-4.3 1.8-4.3 4.2 0 2.4 1.9 4.2 4.3 4.2s4.3-1.8 4.3-4.2c0-2.5-1.9-4.2-4.3-4.2zm0 6.7c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6s-1.1 2.6-2.4 2.6zm-9.3-6.7c-2.4 0-4.3 1.8-4.3 4.2 0 2.4 1.9 4.2 4.3 4.2s4.3-1.8 4.3-4.2c0-2.5-1.9-4.2-4.3-4.2zm0 6.7c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6s-1.1 2.6-2.4 2.6zm-11.1-5.4V25h4.3c-.1 1-.5 1.7-1 2.2-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8s2.1-4.8 4.7-4.8c1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.7 0-6.7 2.9-6.7 6.5s3.1 6.5 6.7 6.5c2 0 3.5-.6 4.6-1.8 1.2-1.2 1.6-2.8 1.6-4.2 0-.4 0-.8-.1-1.1-.1.2-6.2.2-6.2.2zm45.4 1.3c-.4-.9-1.4-2.7-3.7-2.7-2.2 0-4 1.7-4 4.2 0 2.4 1.8 4.2 4.2 4.2 2 0 3.1-1.2 3.6-1.9l-1.5-1c-.5.7-1.1 1.2-2.1 1.2-.9 0-1.6-.4-2.1-1.3l5.7-2.3c.1.1-.1-.4-.1-.4zm-5.8 1.4c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9 0 .1-3.8 1.6-3.8 1.6zM83.1 30H85V17.7h-1.9V30zM80 22.8c-.5-.5-1.3-.9-2.3-.9-2.1 0-4.1 1.9-4.1 4.2 0 2.4 2 4.2 4.1 4.2 1 0 1.8-.4 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4.1-1.3 4.1-4.4v-7.6H80v.7zm-2.2 5.8c-1.3 0-2.4-1.1-2.4-2.5 0-1.5 1.1-2.6 2.4-2.6 1.3 0 2.3 1.1 2.3 2.6s-1 2.5-2.3 2.5zm24.5-10.9h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.8 0-2.4-2.1-3.8-4.1-3.8zm0 5.9h-2.7v-4.2h2.7c1.4 0 2.2 1.1 2.2 2.1s-.8 2.1-2.2 2.1zm11.6-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 2 .6 2 1.6v.1c-.3-.2-1.1-.5-2-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.7 3.1 2.7 1.3 0 2-.6 2.4-1.2h.1v1h1.8v-4.8c-.1-2.1-1.8-3.4-3.9-3.4zm-.2 6.8c-.6 0-1.5-.3-1.5-1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.1-1.2 1.9-2.2 1.9zm10.6-6.5l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.5-1.9 4.2h2l5.1-11.7h-2.1zM107.4 30h1.9V17.7h-1.9V30z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path64_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.252,
    y1: -147.153,
    x2: 14.47,
    y2: -130.371,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -9.248 -114.474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    className: "st2",
    d: "M10.7 7.8c-.3.3-.5.8-.5 1.4v21.9c0 .6.2 1.1.5 1.4l.1.1 12.4-12.3V20L10.7 7.8z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path78_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.288,
    y1: -135.862,
    x2: 19.091,
    y2: -135.862,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -9.248 -114.474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    className: "st3",
    d: "M27.3 24.4l-4.1-4.1V20l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7c.1-.1 0 0 0 0z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path88_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.936,
    y1: -141.911,
    x2: 3.178,
    y2: -119.152,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -9.248 -114.474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    className: "st4",
    d: "M27.4 24.3l-4.2-4.2-12.5 12.4c.5.5 1.2.5 2.1.1l14.6-8.3"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path104_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.409,
    y1: -147.344,
    x2: 18.571,
    y2: -137.181,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -9.248 -114.474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    className: "st5",
    d: "M27.4 15.9L12.8 7.7c-.9-.5-1.6-.4-2.1.1l12.5 12.3 4.2-4.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.5c587b9c012d6d1c346ef58b9da0251e.svg";
export { ForwardRef as ReactComponent };